<template>
  <div class="footer-landing-page">
    <!-- <v-layout align-start justify-start row fill-height gap-20>
      <div class="text-16 font-poppins font-weight-500 w-20">
        <div class="text-grey-purple text-16">Company</div>
        <a href="https://www.intercom.com/about-us" target="_blank" class="text-grey-black text-14 mt-4 d-block">About Us</a>
        <a href="https://www.intercom.com/careers" target="_blank" class="text-grey-black text-14 mt-2 d-block">Careers</a>
        <a href="https://www.intercom.com/faqs" target="_blank" class="text-grey-black text-14 mt-2 d-block">FAQ</a>
      </div>

      <div class="text-16 font-poppins font-weight-500 w-20">
        <div class="text-grey-purple text-16">Resources</div>
        <a href="https://www.intercom.com/royalty-calculator" target="_blank" class="text-grey-black text-14 mt-4 d-block">Royalty Calculator</a>
        <a href="https://www.intercom.com/help-desk" target="_blank" class="text-grey-black text-14 mt-2 d-block">Help Desk</a>
      </div>

      <div class="text-16 font-poppins font-weight-500 w-20">
        <div class="text-grey-purple text-16">Best Practices</div>
        <a href="https://www.intercom.com/creators" target="_blank" class="text-grey-black text-14 mt-4 d-block">Creators</a>
        <a href="https://www.intercom.com/brands" target="_blank" class="text-grey-black text-14 mt-2 d-block">Brands</a>
      </div>
    </v-layout>

    <hr class="styled-divider mt-5" /> -->

    <v-layout align-center justify-space-between row fill-height gap-20 py-4>
      <div>
        <v-layout align-center justify-start row gap-20>
          <div class="black--text text-16 font-weight-500">Join Newsletter</div>
          <div class="input-email bg-white">
            <input
              v-model="email"
              placeholder="Enter your email address"
              class="mx-4 font-poppins text-16 font-weight-500"
            />
            <v-btn color="black" dark @click="storeEmail()" class="tex-16 font-poppins font-weight-600">
              Send!
            </v-btn>
          </div>
        </v-layout>
      </div>
      <div>
        <v-layout align-center row gap-20>
          <a href="https://www.youtube.com/@yousoundapp">
            <div>
              <img
                src="/static/images/landing-page/youtube.svg"
                aspect-ratio="1"
                height="32"
                width="32"
              />
            </div>
          </a>
          <a href="https://www.instagram.com/yousoundapp/">
            <div>
              <img
                src="/static/images/landing-page/instagram.svg"
                aspect-ratio="1"
                height="32"
                width="32"
              />
            </div>
          </a>
          <!-- <div>
            <img
              src="/static/images/landing-page/tik_tok.svg"
              aspect-ratio="1"
              height="32"
              width="32"
            />
          </div>
          <div>
            <img
              src="/static/images/landing-page/x.svg"
              aspect-ratio="1"
              height="32"
              width="32"
            />
          </div> -->
        </v-layout>
      </div>
    </v-layout>

    <v-layout align-center justify-space-between row fill-height gap-20 py-4>
      <div>
        <a
          href="/terms#privacy_policy"
          target="_blank"
          class="text-grey-black-2 text-14"
        >
          Privacy Policy
        </a>
        <a
          href="/terms"
          target="_blank"
          class="text-grey-black-2 text-14 ml-3"
        >
          Terms of Use
        </a>
      </div>
      <div class="text-grey-black-1 text-12 font-weight-500">© 2024 YouSound, Inc.</div>
    </v-layout>
  </div>
</template>

<script>
import NewsletterRecipients from '@/services/newsletter_reciepients'
export default {
  name: "Footer",
  data() {
    return {
      email: '',
    };
  },

  methods: {
    storeEmail() {
      if (!this.validateEmail(this.email)) {
        this.$store.dispatch(
            'error/showErrorToast',
            ['Invalid email address!']
          )
        return;
      }

      const params = { email: this.email };

      NewsletterRecipients.storeRecipient(params)
        .then((res) => {
          console.log(res);
          this.$store.dispatch(
            'error/showSuccessToast',
            res.body || [res.bodyText]
          )
          this.email = '';
        })
        .catch((error) => {
          this.$store.dispatch(
            'error/showErrorToast',
            error.body.errors || [error.body]
          )
        });
    },

    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-landing-page {
  background-color: #eceff2;
  padding: 50px 230px 40px;
}

.input-email {
  padding: 4px;
  margin-left: 20px;
  border-radius: 10px;
  height: 57px;
  input {
    outline: none !important;
  }
}

.styled-divider {
  border: 0;
  height: 1px;
  background-color: #ccc;
  margin-bottom: 10px; /* Adjust this value to match the "mt-5" margin */
}

.input-email input::placeholder {
  outline: none !important;
  font-family: Poppins !important;
  font-size: 16px;
  color: #454545;
  font-weight: 500;
}

.text-grey-black {
  color: #454545;
}

.text-grey-black-1 {
  color: #666;
}

.text-grey-black-2 {
  color: #888;
}

.text-grey-purple {
  color: #000;
}

.text-14 {
  font-size: 14px;
}

.text-16 {
  font-size: 16px;
}

.d-block {
  display: block;
}
</style>



// WEBPACK FOOTER //
// FooterLandingPage.vue?41e842a6